import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import TranslationUtils from 'Utils/TranslationUtils';
import { Helmet } from 'react-helmet';
import PiplLogo from '../../../Assets/pipl.svg';
import { AppSelectors } from '../../../Redux/modules/app/selectors';
import styles from './BlockPage.module.less';

function BlockPage({ blockReason = null }) {
  return (
    <div className={styles.container}>
      <Helmet>
        <title>{gettext('Vetting Not Allowed')}</title>
      </Helmet>
      <a href="https://pipl.com">
        <img src={PiplLogo} alt="" width="80" height="49" />
      </a>
      <div className={styles.content}>
        <span test-id="page-title" className={styles.title}>
          {TranslationUtils.getText('BLOCK_PAGE_TITLE')}
        </span>

        {blockReason && (
          <div className={styles.reason}>
            <span>Reason: </span>
            <span>{TranslationUtils.getText(blockReason)}</span>
          </div>
        )}
      </div>
      <span className={styles.body}>
        {TranslationUtils.getText('BLOCK_PAGE_SUBTITLE')}
        <a href="mailto:support@pipl.com" className={styles.footerLink}>
          <span>{TranslationUtils.getText('BLOCK_PAGE_LINK')}</span>
        </a>
      </span>
      <div className={styles.footer}>
        <a className={styles.footerLink} href="https://pipl.com/">
          <span>{TranslationUtils.getText('EMAIL_CONFIRM_PAGE_FOOTER')}</span>
        </a>
      </div>
    </div>
  );
}

BlockPage.propTypes = {
  blockReason: PropTypes.string,
};

const withConnect = connect((state) => {
  return {
    blockReason: AppSelectors.onBoardingBlockReasonSelector(state),
  };
});

export default withConnect(BlockPage);
